/* eslint-disable class-methods-use-this */

// 因为小程序没有URL类，并且URL类不支持没有域名的路径，自己实现一个
export class URI {
  [x: string]: any;
  constructor(url: any) {
    const { scheme, schemeOther } = this._parseScheme(url);
    this.scheme = scheme;
    if(schemeOther) {
      const { path, query } = this._parseQuery(schemeOther);

      if (query) {
        const { search, hash } = this._parseHash(query);
        this.search = search;
        this.hash = hash;
        if (search) {
          this.searchParams = this._parseSearchParams(search);
          if(path) {
            const { host, pathname } = this._parseHost(path);
            this.host = host;
            this.pathname = pathname;
          }
        }
      }
    }
  }

  _parseScheme(url: string) {
    if (!url) {
      return {};
    }
    const schemeParts = url.split('://');
    let scheme;
    let schemeOther;
    // 长度为1，则表示没有scheme
    if (schemeParts && schemeParts.length === 1) {
      schemeOther = schemeParts[0];
    } else if (schemeParts && schemeParts.length > 1) {
      scheme = schemeParts[0];
      schemeOther = schemeParts[1];
    }
    return { scheme, schemeOther };
  }

  _parseQuery(url: string) {
    if (!url) {
      return {};
    }
    const queryParts = url.split('?');
    let path;
    let query;
    if (queryParts && queryParts.length > 0) {
      path = queryParts[0];
    }
    if (queryParts && queryParts.length > 1) {
      query = queryParts[1];
    }
    return { path, query };
  }

  _parseHash(query: string) {
    if (!query) {
      return {};
    }
    const queryParts = query.split('#');
    let hash;
    let search;
    if (queryParts && queryParts.length > 0) {
      search = queryParts[0];
    }
    if (queryParts && queryParts.length > 1) {
      hash = queryParts[1];
    }
    return { search, hash };
  }

  _parseSearchParams(search: string) {
    if (!search) {
      return {};
    }
    const queryParts = search.split('&');
    const params:any = {};
    for (const query of queryParts) {
      const keyValue = query.split("=");
      if (!keyValue || keyValue.length === 0) {
        continue;
      }
      let key;
      let value;
      if (keyValue.length >= 1) {
        key = keyValue[0];
      }
      if (keyValue.length >= 2) {
        value = keyValue[1];
      }
      key && (params[key] = value);
    }
    return params;
  }

  _parseHost(path: string) {
    if (!path) {
      return {};
    }
    const hostParts = path.split('/');
    let host;
    const pathParts: any[] = [];
    hostParts.forEach((item: string | string[], index: number) => {
      if (index === 0 && item.indexOf('.') >= 0) {
        host = item;
      } else {
        pathParts.push(item);
      }
    });

    let pathname = pathParts.join('/');
    if (pathname.length > 0 && pathname[0] !== '/') {
      pathname = `/${pathname}`;
    }
    return { host, pathname };
  }

  toString() {
    let url = "";
    if (this.scheme && this.scheme.length) {
      url = `${this.scheme}://`;
    }
    if (this.host && this.host.length) {
      url = `${url}${this.host}`;
    }
    if (this.pathname.length) {
      url = `${url}${this.pathname}`;
    }
    if (this.searchParams) {
      let search = "";
      for (const key in this.searchParams) {
        const value = this.searchParams[key];
        if (search.length > 0) {
          search += '&';
        }
        search += `${key}=${value}`;
      }
      if (search.length) {
        url = `${url}?${search}`;
      }
    }
    if (this.hash && this.hash.length) {
      url = `${url}#${this.hash}`;
    }
    return url;
  }
}

export default URI;

